import { MessageBar, MessageBarBody, MessageBarTitle } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const DeleteError = () => {
    const { t } = useTranslation();
    
    return (
        <MessageBar intent="error">
            <MessageBarBody>
                <MessageBarTitle>
                    {t("general.error")}
                </MessageBarTitle>
                {t("folders.errors.deleteFolder")}
            </MessageBarBody>
        </MessageBar>
    );
};

const LoadError = () => {
    const { t } = useTranslation();

    return (
        <MessageBar intent='error'>
            <MessageBarBody>
                <MessageBarTitle>{t("general.error")}</MessageBarTitle>
                {t("folders.errors.loadFolder")}
            </MessageBarBody>
        </MessageBar>
    );
};

export { DeleteError, LoadError };